<template>
  <div class="">
    <PlanList />
    <ActivityToast />
  </div>
</template>

<script>
import PlanList from './components/plan-list.vue'
import ActivityToast from './components/activity-toast.vue'
export default {
  name: 'nutrition-clock-plan-list',
  components: { PlanList, ActivityToast },
  data() {
    return {}
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped></style>
